import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API } from 'src/app/configs/api.config';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  serviceInfo: {
    auth: any,
    dataKeyMaxNum: number,
    dataKeyNum: number,
    expiryDate: any,
    proDeviceMaxNum: number
    proDeviceNum: number,
    diyDeviceMaxNum: number,
    diyDeviceNum: number,
    userLevel: number
  };

  constructor(
    private http: HttpClient,
  ) { }

  getUserProfile(): Promise<boolean> {
    return this.http
      .get(API.PROFILE)
      .toPromise()
      .then(response => {
        console.log(response);
        let data = JSON.parse(JSON.stringify(response));
        if (data.message == 1000) {
          this.serviceInfo = data.detail;
          // this.user.dataKeyNum = data.detail.dataKeyNum;
          // this.user.dataKeyMaxNum = data.detail.dataKeyMaxNum;
          // this.user.proDeviceNum = data.detail.proDeviceNum;
          // this.user.proDeviceMaxNum = data.detail.proDeviceMaxNum;
          // this.user.userLevel = data.detail.userLevel;
          return true
        }
        return false;
      })
      .catch(this.handleError);
  }

  检查认证状态
  isAuthenticated(): Promise<boolean> {
    return this.http
      .get(API.AUTH)
      .toPromise()
      .then(response => {
        console.log(response);
        let data = JSON.parse(JSON.stringify(response));
        if (data.message == 1000) {
          return (data.detail.verified == 1 ? true : false)
        }
      })
      .catch(this.handleError);
  }

  //上传认证信息
  async uploadAuthInfo(authInfo): Promise<boolean> {
    // await this.noticeService.showLoading('upload');
    let formData = new FormData();
    formData.append('vender', authInfo.vender);
    formData.append('idCard', authInfo.idCard);
    if (authInfo.type == 'enterprise')
      formData.append('charter', authInfo.charter);
    return this.http
      .post(API.PROFILE + "/dev/auth", formData)
      .toPromise()
      .then(response => {
        console.log(response);
        // this.noticeService.hideLoading();
        let data = JSON.parse(JSON.stringify(response));
        if (data.message == 1000) {
          console.log("上传成功");
          return true;
        } else {
          console.log("上传失败");
          return false;
        }
      })
      .catch(this.handleError);
  }

  private handleError(error: any): boolean {
    console.error('An error occurred', error);
    return false;
  }

  changePassword(oldPassword, password) {
    return this.http.post<ResponseModel>(API.PROFILE_PASSWORD, {
      "oldPassword": `${CryptoJS.SHA256(oldPassword)}`,
      "password": `${CryptoJS.SHA256(password)}`,
    })
  }

  changePhone(params) {
    return this.http.post<ResponseModel>(API.PROFILE_PHONE, params)
  }

  getSmscode(phone, sendType = "verify") {
    return this.http.get<ResponseModel>(API.PROFILE_SMS, {
      params: {
        phone, sendType
      }
    })
  }
}
